//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

const { locale } = wcs.getStoreConfig()

export default {
  name: 'rb-footer-mention-me-link',
  computed: {
    ...mapGetters(['translation']),
    mentionMeFooterURL() {
      const currentStore = WcsLocales.mapCurrentStore(locale)
      if (locale === WcsLocales.FR_CA) {
        return `${window.location.origin}/${currentStore}/referez-un-ami`
      }
      return `${window.location.origin}/${currentStore}/refer-a-friend`
    },
  },
  methods: {
    onMentionMeFooterButtonClick() {
      window.location.href = this.mentionMeFooterURL
    },
  },
}
